import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PortalStore } from '../shared/state/portal.store';
import { PortalMeData } from '../shared/data/portal-me.models';
import { PortalUser } from '../data/portal-user.model';
import { avatars } from '../shared/data/avatars';

/**
 * Provee la identidad del cliente autenticado para el shell del portal, derivada del PortalStore
 * (/portal/me): nombre/email/iniciales desde credit.client (cliente ARDEL) con fallback a loans.contact. Degrada a
 * un usuario genérico si aún no hay datos.
 */
@Injectable({ providedIn: 'root' })
export class PortalUserService {
  readonly user$: Observable<PortalUser> = this.store.me$.pipe(map((me) => this.toUser(me)));

  constructor(private readonly store: PortalStore) {
    this.store.load();
  }

  private toUser(me: PortalMeData | null): PortalUser {
    const loans = me?.loans;
    const credit = me?.credit;
    const nombre =
      [credit?.client.firstName, credit?.client.lastName].filter(Boolean).join(' ').trim() ||
      [loans?.contact.firstName, loans?.contact.lastName].filter(Boolean).join(' ').trim() ||
      'Cliente Rayo';
    const email = credit?.client.email || loans?.contact.email || '';
    const avatarUrl = credit?.client.avatarUrl || avatars[0].url;
    return { nombre, email, avatarUrl };
  }
}
